/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Eric Chu
*/
import { connect } from 'react-redux';
import { openGlobalSearch as _openGlobalSearch, closeGlobalSearch as _closeGlobalSearch, setGlobalSearchValue as _setGlobalSearchValue, navigateGlobalSearch as _navigateGlobalSearch, setGlobalSearchResults as _setGlobalSearchResults, fetchGlobalSearchResults as _fetchGlobalSearchResults, fetchGlobalSearchSuggestions as _fetchGlobalSearchSuggestions, clearGlobalSearchSuggestions, setGlobalSearchMode as _setGlobalSearchMode } from '../../store/global-search/actions';
export var mapStateToProps = function mapStateToProps(state) {
  var globalSearch = state.core.globalSearch;
  return {
    globalSearchActive: globalSearch.open,
    searchUrl: globalSearch.searchUrl,
    searchResultsBean: globalSearch.searchResultsBean,
    globalSearchSwitch: globalSearch.open,
    globalSearchValue: state.core.globalSearch.searchValue,
    suggestions: globalSearch.suggestions,
    showResults: globalSearch.showResults
  };
};
export var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openGlobalSearch: function openGlobalSearch() {
      dispatch(_openGlobalSearch());
    },
    closeGlobalSearch: function closeGlobalSearch() {
      dispatch(_closeGlobalSearch());
    },
    setGlobalSearchValue: function setGlobalSearchValue(searchValue) {
      dispatch(_setGlobalSearchValue(searchValue));
    },
    setGlobalSearchResults: function setGlobalSearchResults(response) {
      dispatch(_setGlobalSearchResults(response));
    },
    fetchGlobalSearchResults: function fetchGlobalSearchResults() {
      dispatch(_fetchGlobalSearchResults());
    },
    fetchGlobalSearchSuggestions: function fetchGlobalSearchSuggestions() {
      dispatch(_fetchGlobalSearchSuggestions());
    },
    navigateGlobalSearch: function navigateGlobalSearch(payload, url) {
      dispatch(_navigateGlobalSearch(payload, url));
    },
    clearSuggestions: function clearSuggestions() {
      dispatch(clearGlobalSearchSuggestions());
    },
    setGlobalSearchMode: function setGlobalSearchMode(mode) {
      dispatch(_setGlobalSearchMode(mode));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps);